/* eslint-disable no-unused-vars */
export enum FESTIVAL_TYPE {
  WONDER = "wonder",
  PERCENT = "percent",
  STEPPED_AMOUNT = "stepped_amount",
  STEPPED_COUNT = "stepped_quantity",
}
